import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getHomePage = createAsyncThunk('homePage/getHomePage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getHomePage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
